import React from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from '../components/LandingPage';
import { getLanding } from '../data/seoLandings';

// Renders a data-driven SEO landing page from src/data/seoLandings.js.
// `slug` is passed in per-route from index.js so each page is a real URL.
export default function SeoLanding({ slug }) {
  const cfg = getLanding(slug);
  if (!cfg) return <Navigate to="/" replace />;
  return <LandingPage {...cfg} />;
}
